module.exports = __webpack_public_path__ + "static/aycm-d3e6ad0fc81f52a4831af7fcd816dcf1.jpg";